import {observable, action, runInAction} from 'mobx'
import emailManagementAPI from '../apis/emailManagementAPI'
import alertMessage from '../utils/alertMessage'
import moment from 'moment'

export default class emailManagementStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable alarmData = {}

  @action
  async alarmSave(params) {
    this.isFetching = true
    try {
      const response = await emailManagementAPI.alarmSave(params)
      runInAction(() => {
        if (response.data.code === 0) {
          alertMessage.success(response.data.message)
        }
        this.isFetching = false
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async getAlarm(params) {
    this.isFetching = true
    try {
      const response = await emailManagementAPI.getAlarm(params)
      runInAction(() => {
        this.alarmData = response.data.data
        this.alarmData.sendTime = moment(this.alarmData.sendTime, 'HH:mm:ss')
        this.isFetching = false
      })
      return response
    } catch (err) {
       alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
}
